<template>
  <section>
    <b-field label="Type" horizontal>
      <c-select v-model="value.type" />
    </b-field>
    <template v-if="value.type.data === 's3'">
      <b-field label="Key" horizontal>
        <c-input v-model="value.s3_key" />
      </b-field>
      <b-field label="Secret" horizontal>
        <c-input v-model="value.s3_secret" />
      </b-field>
      <b-field label="Bucket" horizontal>
        <c-input v-model="value.s3_bucket" />
      </b-field>
      <b-field label="Region" horizontal>
        <c-input v-model="value.s3_region" />
      </b-field>
      <b-field label="Version" horizontal>
        <c-input v-model="value.s3_version" />
      </b-field>
    </template>
    <template v-else-if="value.type.data === 'local'">
      <b-field label="Public Dir" horizontal>
        <c-input v-model="value.local_public_dir" />
      </b-field>
      <b-field label="Private Dir" horizontal>
        <c-input v-model="value.local_private_dir" />
      </b-field>
    </template>
  </section>
</template>

<script>
import CInput from '@/lib/components/Input'
import CSelect from '@/lib/components/Select'

export default {
  name: 'file-manager',
  props: ['value', 'fieldErrors'],
  components: {
    CInput,
    CSelect,
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Projects/Form/Custom/FileManager.vue